import {
  ChatTitle,
  NEW_CHAT_TITLE,
} from '@/components/ui/window-title/ChatTitle';
import { uiStore } from '@/stores/ui.store';

export function useSetChatWindowTitle() {
  return ({ threadId, title }: { threadId: string; title?: string }) =>
    uiStore.setWindowTitle({
      title: <ChatTitle threadId={threadId} />,
      altTitle: title ?? NEW_CHAT_TITLE,
    });
}
